// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-lang[data-v-17ff5f10] {\n  padding: 5px 10px;\n  color: #fff;\n  background-color: #012755;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
